if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      // If this product uses a size dropdown and no variant is selected yet,
      // open the dropdown instead of submitting the form.
      let sectionId = null;
      if (this.id && this.id.indexOf('product-form-') === 0) {
        sectionId = this.id.replace('product-form-', '');
      } else if (this.form) {
        const formId = String(this.form.getAttribute('id') || this.form.id || '');
        if (formId.indexOf('product-form-') === 0) {
          sectionId = formId.replace('product-form-', '');
        }
      }
      if (!sectionId && this.form) {
        const sectionInput = this.form.querySelector('input[name="section-id"]');
        if (sectionInput && sectionInput.value) sectionId = sectionInput.value;
      }

      const scopeRoot =
        this.closest('quick-add-modal') ||
        this.closest('floated-form') ||
        this.closest('[id^="ProductInfo-"]') ||
        this.closest('.product__popup') ||
        document;

      let variantRadios = null;
      if (sectionId) {
        variantRadios = scopeRoot.querySelector(`variant-radios[data-section="${sectionId}"]`);
      }
      if (!variantRadios) {
        variantRadios = scopeRoot.querySelector('variant-radios');
      }

      if (
        variantRadios &&
        typeof variantRadios.hasDropdownWithNoSelection === 'function' &&
        variantRadios.hasDropdownWithNoSelection()
      ) {
        const dropdownTrigger = variantRadios.querySelector(
          '.product-form__controls--dropdown .select-label'
        );
        if (dropdownTrigger) dropdownTrigger.click();
        return;
      }

      // Fallback for contexts where variant-radios isn't resolved:
      // if the local dropdown has no selection yet, open it.
      const localDropdown = scopeRoot.querySelector('.product-form__controls--dropdown');
      if (localDropdown) {
        const localChecked = localDropdown.querySelector('input[type="radio"]:checked');
        if (!localChecked) {
          const localTrigger = localDropdown.querySelector('.select-label');
          if (localTrigger) {
            localTrigger.click();
            return;
          }
        }
      }

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        if (typeof this.cart.getSectionsToRender === 'function') {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        }
        formData.append('sections_url', window.location.pathname);
        if (typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          }
          this.error = false;

          if (!this.cart) {
            // Allow third-party cart drawers (e.g. app drawers) to react to cartUpdate
            // without forcing a hard redirect to /cart.
            return;
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              if (this.cart && typeof this.cart.renderContents === 'function') {
                setTimeout(() => { this.cart.renderContents(response) });
              }
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            if (this.cart && typeof this.cart.renderContents === 'function') {
              this.cart.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
